import React, { useState, useEffect, useContext } from "react";
import TaskForm from "../components/Task/TaskForm";
import TaskList from "../components/Task/TaskList";
import { fetchWorkspaces, fetchProjects } from "../api/api";
import { AuthContext } from "../context/AuthContext";

const Tasks = () => {
  const { user } = useContext(AuthContext);

  const [workspaces, setWorkspaces] = useState([]);
  const [selectedWorkspace, setSelectedWorkspace] = useState(null);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    if (!user?.id) return;

    const loadWorkspaces = async () => {
      const data = await fetchWorkspaces(user.id);
      setWorkspaces(data || []);
      if (data?.length) setSelectedWorkspace(data[0].id);
    };

    loadWorkspaces();
  }, [user]);

  useEffect(() => {
    if (!selectedWorkspace) return;

    const loadProjects = async () => {
      const data = await fetchProjects(selectedWorkspace);
      setProjects(data.projects || []);
      setSelectedProject(data?.projects?.length ? data.projects[0].id : null);
    };

    loadProjects();
  }, [selectedWorkspace]);

  return (
    <div>
      <h3 className="mb-4">Tasks</h3>

      {workspaces.length > 0 && (
        <select
          className="form-select mb-3"
          value={selectedWorkspace}
          onChange={(e) => setSelectedWorkspace(Number(e.target.value))}
        >
          {workspaces.map((ws) => (
            <option key={ws.id} value={ws.id}>
              {ws.name}
            </option>
          ))}
        </select>
      )}

      {projects.length > 0 && (
        <select
          className="form-select mb-3"
          value={selectedProject}
          onChange={(e) => setSelectedProject(Number(e.target.value))}
        >
          {projects.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name}
            </option>
          ))}
        </select>
      )}

      {selectedProject && (
        <TaskForm
          project_id={selectedProject}
          workspace_id={selectedWorkspace}
          onTaskCreated={() => setRefresh(!refresh)}
        />
      )}

      {selectedProject && <TaskList project_id={selectedProject} refresh={refresh} />}
    </div>
  );
};

export default Tasks;
